import { useBodySize } from "./useBodySize";
import { useClickOutside } from "./useClickOutside";
import { useContainerSize } from "./useContainerSize";
import { useDebounce } from "./useDebounce";
import { useDropdownKeyDown } from "./useDropdownKeyDown";
import { useInViewport } from "./useInViewPort";
import { useScroll } from "./useScroll";

export const hooks = {
  useBodySize,
  useClickOutside,
  useContainerSize,
  useDropdownKeyDown,
  useInViewport,
  useScroll,
  useDebounce,
};
